import { atom } from 'nanostores';
import type { UserData, OwnedPaidTemplate } from '~/services/interfaceService';

export type UniqueId = {
  uniqueId: string;
};

export const uniqueIdStore = atom<UniqueId>({
  uniqueId: '',
});

export function setUniqueId(uniqueId: string) {
  uniqueIdStore.set({ uniqueId });
  console.log('[User] uniqueId: ', uniqueId, 'uniqueIdStore: ', uniqueIdStore.get());
}

export const userStore = atom<UserData>({
  email: 'user_email@dummy.dualite',
  name: 'Dummy User',
  inviteCode: 'dummy-invite-code',
  created_at: new Date(),
  isSubscribed: false,
  maxPrompts: '20',
  promptsUsed: '0',
  planName: 'Free',
  topUpPrompts: '0',
  topUpPromptsUsed: '0',
  image: '',
  ownedPaidTemplateKeys: [] as OwnedPaidTemplate[],
});

/**
 * Store for user ID (token) - set from root loader
 * This is the external token that represents the user ID
 */
export const userIdStore = atom<string>('');

export function setUserId(userId: string) {
  userIdStore.set(userId);
  console.log('[User] userId set:', userId ? userId.substring(0, 10) + '...' : 'empty');
}
